import React from "react";


export default function Footer() {
const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div>
          <strong>AZ Facility Management</strong>
          <div>Serving Arizona Commercial Properties</div>
          </div>
            <div className="brand-tag">ROC#361026 • Licensed Bonded and Insured</div>
          <div className="footer-middle">
            <a href="/PrivacyPolicy" className="footer-link">Privacy</a>
            <span className="dot" />
            <a href="/TermsOfService" className="footer-link">Terms</a>
            <span className="dot" />
            <a href="/RefundPolicy" className="footer-link">Refunds</a>
            <span className="dot" />
            <a href="/Accessibility" className="footer-link">Accessibility</a>
          </div>
          <div className="footer-right">
            <a href="mailto:service@azfacilitymanagement.com" className="footer-link">service@azfacilitymanagement.com</a>
          </div>
        </div>
      <div className="footer-bottom">© {year} AZ Facility Management • All rights reserved</div>
    </footer>
  );
}
